import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';

const wrapperWithoutNavbar = {
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  paddingTop: 84,
};

const printReset = {
  '@media print': {
    height: 'auto',
    overflow: 'visible',
    padding: 0,
  },
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    '@media print': {
      display: 'block',
      height: 'auto',
      overflow: 'visible',
      '& .MuiAppBar-root': {
        display: 'none',
      },
      '& .MuiDrawer-root': {
        display: 'none',
      },
    },
  },
  wrapperWithoutNavbar: {
    ...wrapperWithoutNavbar,
    ...printReset,
  },
  wrapper: {
    ...wrapperWithoutNavbar,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 206,
    },
    ...printReset,
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    ...printReset,
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    ...printReset,
  },
}));

export default useStyles;
